import { Box, Button, Typography } from '@mui/material';
import React from 'react';

class Labels extends React.Component {
    public render(): React.ReactNode {
        return (
            <Box flexDirection='column'>
                <Box display='flex'>
                    {/* TODO this box mostly differs in title but always has buttons with actions,
                    maybe move it separate component*/}
                    <Box flexGrow={1}>
                        <Typography variant='h4'>Label Tuples</Typography>
                    </Box>
                    <Box flexGrow={0}>
                        <Button type='button' variant='contained' color='primary'>
                            Save
                        </Button>
                        <Button type='button' variant='text' color='primary'>
                            Finish Work
                        </Button>
                    </Box>
                </Box>
                <Box display='flex' className='mt-2'>
                    <Box flexGrow={1}>Table</Box>
                    <Box flexGrow={0}>
                        <Typography variant='h6'>Filter by Label</Typography>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export { Labels };
